import getApi from "../api/getApi";
import patchApi from "../api/patchApi";
import postApi from "../api/postApi";
import * as url from "../api/url";

export const updateAzureUser = (appClientId, payload, header) => {
  return new Promise(async (resolve, reject) => {
    return patchApi
      .patch(`${url.GraphAPI}/${appClientId}`, payload, header)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getAzureUser = (query, header) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GraphAPI}/${query}`, header)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
